exports = module.exports = require("../../../node_modules/css-loader/lib/css-base.js")(false);
// imports


// module
exports.push([module.id, "\n.page-wrap[data-v-2e2e183c]{min-height:calc(100vh - 389px)\n}", ""]);

// exports
